import { render, staticRenderFns } from "./EncabezadoModal.vue?vue&type=template&id=5ddd2cea"
import script from "./EncabezadoModal.vue?vue&type=script&lang=js"
export * from "./EncabezadoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports